module.exports = __webpack_public_path__ + "static/media/placeholder.a0c5e3db.png";